import cookies from './cookies'
import { ensureCookiesVersion } from './cookieVersion'

interface CookieData {
  name: string;
  value: string;
  attributes?: string;
}

let cookieBuffer: CookieData[] = [];
let consentGiven = false
let interval = null;

export function bufferExistingCookies() {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [name, ...rest] = cookie.split('=');
    const value = rest.join('=');
    cookieBuffer.push({ name, value });
    deleteCookie(name);
  }
}

function deleteCookie(name: string) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

const originalCookieDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
  Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

Object.defineProperty(document, 'cookie', {
  get() {
    return originalCookieDescriptor?.get?.call(document);
  },
  set(value: string) {
    ensureCookiesVersion()
    let consent = localStorage.getItem('cookies_v2') || localStorage.getItem('cookies')
    if(value.includes('Max-Age=0')) {
      originalCookieDescriptor?.set?.call(document, value);
      return;
    }
    if (consentGiven && consent) {
      consent = JSON.parse(consent)
      const [cookiePair] = value.split('; ');
      const [name] = cookiePair.split('=');
      const allowed = Object.entries(consent).map(([key, value]) => {
        if(!value) return undefined
        return cookies[key]
      }).filter(Boolean).reduce((a,b) => a.concat(b), []).map(b => b.title)
      if(allowed.some(a => name.includes(a)) || (name.includes('mixpanel') && consent['necessary'])) {
        originalCookieDescriptor?.set?.call(document, value);
      }
    } else {
      const [cookiePair, ...attributePairs] = value.split('; ');
      const [name, ...rest] = cookiePair.split('=');
      const cookieValue = rest.join('=');
      const attributes = attributePairs.join('; ');
      cookieBuffer.push({ name, value: cookieValue, attributes });
    }
  }
});


export function giveConsent() {
  consentGiven = true;
  clearInterval(interval)
  bufferExistingCookies()
  restoreBufferedCookies();
}

export function restoreBufferedCookies() {
  for (const cookie of cookieBuffer) {
    let cookieString = `${cookie.name}=${cookie.value}`;
    if (cookie.attributes) {
      cookieString += `; ${cookie.attributes}`;
    }
    document.cookie = cookieString;
  }
  cookieBuffer = [];
}


window.addEventListener('load', () => {
  const hasValidVersion = ensureCookiesVersion()
  let consent = localStorage.getItem('cookies_v2') || localStorage.getItem('cookies')
  const expire = localStorage.getItem('cookies_expire_v2') || localStorage.getItem('cookies_expire')
  const isExpired = (() => {
    if (!expire) return false
    const d = new Date(expire)
    return isNaN(d.getTime()) ? false : new Date() >= d
  })()

  if (consent && !isExpired && hasValidVersion) {
    giveConsent()
    return;
  } else {
    // remove stale consent if expired to allow modal to open by existing logic
    if (isExpired) {
      try { localStorage.removeItem('cookies') } catch (e) {}
      try { localStorage.removeItem('cookies_v2') } catch (e) {}
    }
    interval = setInterval(() => {
      bufferExistingCookies();
    }, 500)
  }
});
